// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__OkeRP","header-select":"SelectProduct_header-select__g7n2o"};